module.exports = __webpack_public_path__ + "images/8ff321535d3bc43d713f04d6c01380c8.jpg";